export enum UploadStatus {
  QUEUED = "QUEUED",
  UPLOADING = "UPLOADING",
  PROCESSING = "PROCESSING",
  PENDING_CONFIRMATION = "PENDING_CONFIRMATION",
  ERROR = "ERROR",
}

export type Upload = {
  id: string;
  uploadUrl?: string;
  file?: File;
  progress?: number;
  status?: UploadStatus;
  hidden?: boolean;
  splits?: Split[];
};

export type Split = {
  id: string;
  indexes: number[];
  classification?: string;
  pageCount?: number;
  file?: File;
};

export type DropzoneFile = {
  file: File;
  name: string;
  loading: boolean | null;
  split: boolean;
  numberOfPages: number | null;
  disableSplit: boolean;
};
